import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import AiImportMenuView from 'components/ImportMenu/AiImportMenuView';
import {
  importMenuV2,
  emptyMenuHistoryV2,
  getMenuMetadata,
} from 'redux/actions/Menu/menuV2';

const BREAK_GLASS_PAGE = 'menu-import';
const EMPTY_ACTION_SUMMARY = 'Empty menu for this business';

const MenuAiImport = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const businessUuid = useSelector(
    ({ business }) => business.currentBusiness?.uuid
  );
  const menuId = useSelector(({ menu }) => menu.menu?._id);

  // Ensure we have the menu id needed for the empty endpoint
  useEffect(() => {
    if (!menuId) {
      dispatch(getMenuMetadata()).catch(() => null);
    }
  }, [menuId, dispatch]);

  const handleEmpty = () => {
    if (!menuId) {
      toast.error(t('Menu is not loaded yet. Please try again.'));
      return Promise.reject(new Error('Missing menu id'));
    }
    return dispatch(emptyMenuHistoryV2([menuId], businessUuid));
  };

  return (
    <AiImportMenuView
      businessUuid={businessUuid}
      target="regular"
      breakGlassPage={BREAK_GLASS_PAGE}
      breakGlassEventType="menu-import-action"
      emptyActionSummary={EMPTY_ACTION_SUMMARY}
      comingSoonProviders={[]}
      onImport={(menu) => dispatch(importMenuV2(businessUuid, menu))}
      onEmpty={handleEmpty}
    />
  );
};

export default MenuAiImport;
